/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Apply_NowInputs */

const en_faq_apply_now = /** @type {(inputs: Faq_Apply_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Now`)
};

const es_faq_apply_now = /** @type {(inputs: Faq_Apply_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplica ahora`)
};

/**
* | output |
* | --- |
* | "Apply Now" |
*
* @param {Faq_Apply_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_apply_now = /** @type {((inputs?: Faq_Apply_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Apply_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_apply_now(inputs)
	return en_faq_apply_now(inputs)
});